import { useState } from 'react';
import { communityVoices } from '@/mocks/home';

export default function CommunitySection() {
  const [liked, setLiked] = useState<Record<number, boolean>>({});
  const [featured, ...rest] = communityVoices;

  const toggleLike = (id: number) => {
    setLiked((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <section id="community" className="w-full bg-secondary-50 py-16 md:py-24 scroll-mt-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-2xl mb-10">
          <p className="text-xs tracking-[0.3em] text-secondary-700 font-medium mb-2">COMMUNITY</p>
          <h2 className="font-heading font-black text-2xl md:text-4xl text-foreground-950">
            瓜友交流区正在热闹
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            每个人都可以在这里补充线索、发表看法。氛围热闹但不失分寸，这也是很多瓜友愿意长期留下来的原因。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-8">
          <blockquote className="lg:col-span-5 bg-secondary-950 text-background-100 rounded-lg p-7 md:p-9 flex flex-col justify-between">
            <span className="text-accent-400 text-3xl font-heading leading-none">“</span>
            <p className="mt-4 text-base md:text-lg leading-relaxed text-background-100/95">
              {featured.content}
            </p>
            <footer className="mt-8 flex items-center gap-3">
              <span className="w-11 h-11 flex items-center justify-center rounded-full bg-accent-500 text-secondary-950 font-heading font-black">
                {featured.avatar}
              </span>
              <span>
                <cite className="not-italic font-heading font-bold text-background-50 block">
                  {featured.name}
                </cite>
                <span className="text-xs text-background-200/80">
                  {featured.role} · 常聊 {featured.topic}
                </span>
              </span>
            </footer>
          </blockquote>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-6">
            {rest.map((voice) => (
              <article
                key={voice.id}
                className="bg-background-50 border border-secondary-200/70 rounded-lg p-6 flex flex-col"
              >
                <div className="flex items-center gap-3">
                  <span className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-800 font-heading font-bold">
                    {voice.avatar}
                  </span>
                  <span>
                    <p className="font-heading font-bold text-sm text-foreground-950">{voice.name}</p>
                    <p className="text-xs text-foreground-500">{voice.role}</p>
                  </span>
                </div>
                <p className="mt-4 text-sm text-foreground-700 leading-relaxed flex-1">
                  {voice.content}
                </p>
                <div className="mt-5 flex items-center justify-between">
                  <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-800 text-[11px]">
                    {voice.topic}
                  </span>
                  <button
                    type="button"
                    onClick={() => toggleLike(voice.id)}
                    aria-pressed={!!liked[voice.id]}
                    aria-label={`赞同 ${voice.name} 的观点`}
                    className={`flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full transition-colors cursor-pointer ${
                      liked[voice.id]
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-background-100 text-foreground-600 hover:bg-primary-50 hover:text-primary-600'
                    }`}
                  >
                    <i className="ri-thumb-up-line" aria-hidden="true"></i>
                    {voice.likes + (liked[voice.id] ? 1 : 0)}
                  </button>
                </div>
              </article>
            ))}
          </div>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-4 bg-background-50 border border-secondary-200/70 rounded-lg px-6 py-5">
          <p className="text-sm text-foreground-700 text-center sm:text-left">
            你有更完整的线索或不同看法？欢迎加入讨论，一起把话题聊明白。
          </p>
          <a
            href="#subscribe"
            className="shrink-0 inline-flex items-center gap-2 px-5 h-11 rounded-md bg-secondary-600 hover:bg-secondary-700 text-background-50 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-chat-3-line" aria-hidden="true"></i>
            加入吃瓜队列
          </a>
        </div>
      </div>
    </section>
  );
}